import {useState} from "react";
import {TextField} from "@mui/material";
import {splitNumbers} from "../../utils";

// Paste numbers (one per line) or type one and press Enter
export const PhoneNumbersInput = ({onAdd, label = "Phone numbers"}) => {
  const [value, setValue] = useState("");

  const handlePaste = (e) => {
    const values = splitNumbers(e.clipboardData?.getData("text"));
    if (values.length === 0) return;
    e.preventDefault();
    onAdd(values);
    setValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onAdd(splitNumbers(value));
      setValue("");
    }
  };

  return (
    <TextField
      label={label} fullWidth size="small"
      placeholder="Paste phone numbers (one per line) or type one and press Enter"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onPaste={handlePaste}
      onKeyDown={handleKeyDown}
    />
  )
}
